import styled from "styled-components";

export const MyProfileContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: #4747471c;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  top: 0;
  z-index: 7;
  backdrop-filter: blur(6px);

  @media (max-width: 768px) {
    position: relative;
    z-index: 1;
    background: #fff;
    height: 100%;
  }
`;

export const BackButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 31%;

  @media (max-width: 768px) {
    display: none;
  }

  button {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
`;
export const MyProfileWrapper = styled.div`
  width: 30vw;
  max-height: 85vh;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }

  @media (max-width: 768px) {
    width: 95%;
    padding: 10px 20px;
    height: 80vh;
    border-radius: 0;
    border-top: 1px solid #33333352;
  }
`;
export const ProfileInformationWrapper = styled.span`
  background-color: #e6e6e68c;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  gap: 10px;
  flex-direction: column;
`;
export const ProfileImage = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;

  img {
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 50%;
  }
  div {
    display: flex;
    flex-direction: column;
    gap: 7px;

    span {
      text-transform: capitalize;
    }
    span:nth-child(1) {
      font-size: 16px;
      color: #000;
      font-weight: 500;
    }
  }
`;
export const ProfileInformation = styled.span`
  display: flex;
  align-items: flex-start;
  gap: 7px;
  flex-direction: column;

  div {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    transition: 0.5s ease;
    width: 100%;

    span:nth-child(2) {
      color: #000;
      width: 100%;
    }

    textarea {
      width: 100%;
      resize: none;
      font-size: 16px;
      padding: 5px;
      border-radius: 5px;
      border: 1px solid #ccc;
      outline: none;
    }

    span:nth-child(3) {
      button {
        cursor: pointer;
        padding: 10px;
        color: #000;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ccc;
      }
    }
  }
`;

export const MyProfileContentTemplate = styled.span`
  background-color: #e6e6e68c;
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-direction: column;
  padding-bottom: 10px;

  div {
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    width: 95%;

    &:hover {
      background-color: #fff;
      cursor: pointer;
    }
    span {
      text-transform: capitalize;
      color: #000;
    }
  }
`;
export const Title = styled.span`
  border-bottom: 1px solid #33333352;
  width: 95%;
  font-size: 13px;
  padding: 10px;
  text-transform: uppercase;
`;
